<svg #svg width="200" xmlns="http://www.w3.org/2000/svg">
  <title>{{ segment?.title || "Event" }}</title>
</svg>
